module.exports = __webpack_public_path__ + "static/mobile-development-bf463c38d158299be7b8e12b75ae438d.jpg";